
import { Component, Vue } from "vue-property-decorator";
import { Next, Route } from 'vue-router';
import   MenuItemVue from "./MenuItemVue.vue";
import HistoryVue from "@/router/HistoryVue.vue";
import Bus from "@/lib/Bus";
import ModalVue from "@/Modal.vue";
import ButtonVue from "@/lib/Button.vue";

import { ITree } from "@/tree/ITree";
import { TreeSvc } from "@/tree/TreeSvc";
import { IPrj } from "@/prj/IPrj";
import { RouterHistory, RouterObj } from '../router/RouterHistory';
import { LblSvc } from "@/lbl/LblSvc";
const history: RouterHistory = new RouterHistory().class();


const bus: Bus = new Bus().getBus();
@Component({ 
    components: {  MenuItemVue, ModalVue,  ButtonVue, 'history-vue':HistoryVue } 
})




export default class MenuVue extends Vue {
    
    prj_key=0
    prj_idn:string =  ""
    prj_id:any

    tree_key=0;
    tree_idn:string =  ""
    tree_id:any

    lbl_tree_key=0
    lbl_tree_id:string=""

    lbl_key=0;
    lbl_idn:string=""
    lbl_id:any;

    logged_in = false;

    key=0;    
   

    get routes() {    return this.$router.options.routes;    }
 

    created() { 
      bus.register("history_changed",this.refresh)   
      bus.register("on_login", this.on_login);
      bus.register("on_logout", this.on_logout);
    }

    beforeDestroy() {  
      bus.remove("history_changed",this.refresh);
      bus.remove("on_login", this.on_login);
      bus.remove("on_logout", this.on_logout);
    }  

    async on_login(e: any) {
      await this.refresh();
    }

    async on_logout(e: any) {
      await this.refresh();
    }

    async mounted() {
      await this.refresh()
    }
    
    async refresh() {
      this.logged_in = await bus.get_logged_in();
      if (!this.logged_in) {
        this.key=0;
        return;
      }

      this.prj_key=0
      this.prj_idn = ""
      this.prj_id=""

      this.tree_key = 0;
      this.tree_idn = ""
      this.tree_id=""

      this.lbl_tree_key=0
      this.lbl_tree_id=""

      this.lbl_key=0
      this.lbl_idn = ""
      this.lbl_id=""

      console.log(this.$route.params)

      const tree_id = this.$route.params.id
      let tprj_id = null

      if (tree_id) {
        const t:ITree|undefined = await new TreeSvc().find_by_id( tree_id );
        if (t && t._id) {
          if (t.parent_id) tprj_id=t.parent_id
          if (t.idn) this.tree_idn = t.idn;
          this.tree_id=t._id;
        }
      }


      this.lbl_tree_id = ""
      const lbl_id = this.$route.params.lbl_id
      if (lbl_id) {
        const lbl = await new LblSvc().find_by_id(lbl_id);
        if (lbl && lbl._id && lbl.idn) {
          this.lbl_idn = lbl.idn
          this.lbl_id = lbl._id
          if (lbl.tree_id) {
            this.lbl_tree_id = lbl.tree_id
            this.lbl_tree_key++
          }
        }
      }

      this.prj_id = this.$route.params.prj_id ? this.$route.params.prj_id:tprj_id;
      if (this.prj_id) {
        const p:IPrj|undefined = await new TreeSvc().find_prj_by_id( this.prj_id );
        if (p && p._id && p.idn) this.prj_idn = p.idn;
      }
      

      
      //const routes = history.get_routes();

      if (this.prj_idn) this.prj_key++
      if (this.tree_idn) this.tree_key++
      if (this.lbl_idn) this.lbl_key++
      

      if (this.prj_idn || this.tree_idn || this.lbl_idn ) {
        const r=new RouterObj()
        r.path=this.$router.currentRoute.path
        r.title=this.title
        history.add(r)
      }

      this.key++
    }



    get title() {
      let name= this.$route.name +" : "+this.prj_idn+"  "+ this.tree_idn+"  "+this.lbl_idn+" "
      return name
    }
  
}
